import React from "react";
import Modal from "react-modal";
import "./alert.scss";

Modal.setAppElement("#root");

const customStyles = {
	overlay: {
		zIndex: "100",
		backgroundColor: "rgba(0, 0, 0, 0.7)"
	},
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		padding: "0",
		width:"260px",
		minHeight:"140px",
		transform: "translate(-50%, -50%)"
	}
};

class AlertPage extends React.Component {
	constructor(props) {
		super(props);
		this.openModal = this.openModal.bind(this);
		this.afterOpenModal = this.afterOpenModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
	}

	openModal() {
		this.setState({modalIsOpen: true});
	}
 
	afterOpenModal() {
		
	}
 
	closeModal(answer) {
		this.props.close(answer);
	}

	render() {
		let btns;
		if( !this.props.isConfirm ){
			btns = (
			<div className="btns">
				<button
					onClick={()=>this.closeModal(true)}
				>OK</button>
			</div>
			);
		} else {
			btns = (
			<div className="btns">
				<button
					className="confirm yes"
					onClick={()=>this.closeModal(true)}
				>YES</button>
				<button
					className="confirm no"
					onClick={()=>this.closeModal(false)}
				>NO</button>
			</div>
			);
		}
		return (
			<Modal
				isOpen={this.props.isOpen}
				onRequestClose={this.closeModal}
				onAfterOpen={this.afterOpenModal}
				style={customStyles}
			>
			<div id="alert">
				<div className="text">
				{this.props.message.split("\n").map((m,i) => {
					const key = "span"+i;
					return (
						<span key={key}>
							{m}
							<br />
						</span>
					)})}
				</div>
				{btns}
			</div>
			</Modal>
		);
	}
}

export default AlertPage;